// Wraps MissionMap in a 3-column grid — left/right rails fill the empty margins on wide screens.
// On mobile, falls back to the original centered MissionMap only.

import MissionMap from "./MissionMap";
import ProgressRail from "./ProgressRail";
import LearningRail from "./LearningRail";

export default function MissionMapLayout({ wordStates, sessions, onStart, onPractice, loading, isMobile }) {
  if (isMobile) {
    return <MissionMap wordStates={wordStates} onStart={onStart} loading={loading} />;
  }

  return (
    <div style={{
      maxWidth: 1480,
      margin: "0 auto",
      display: "grid",
      gridTemplateColumns: "220px minmax(0, 1fr) 230px",
      gap: 20,
      alignItems: "start",
    }}>
      <aside style={{ position: "sticky", top: 96 }}>
        <ProgressRail wordStates={wordStates} sessions={sessions} dailyGoal={5} />
      </aside>

      <div style={{ minWidth: 0 }}>
        <MissionMap wordStates={wordStates} onStart={onStart} loading={loading} />
      </div>

      <aside style={{ position: "sticky", top: 96 }}>
        <LearningRail wordStates={wordStates} onPractice={onPractice} />
      </aside>
    </div>
  );
}
